import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DirtyCheckGuard, FusionAuthGuard } from '../../../shared/guard';

import { RequisitionCreateComponent } from './pages/requisition-create/requisition-create.component';
import { RequisitionSearchComponent } from './pages/requisition-search/requisition-search.component';

const routes: Routes = [
    {
        path: 'search',
        component: RequisitionSearchComponent,
        canActivate: [FusionAuthGuard],
        data: { roles: ['Superuser', 'Client Admin', 'Client Basic', 'Physician'] },
    },
    {
        path: 'create',
        component: RequisitionCreateComponent,
        canActivate: [FusionAuthGuard],
        canDeactivate: [DirtyCheckGuard],
        data: { roles: ['Superuser', 'Client Admin', 'Client Basic', 'Physician'] },
    }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RequisitionsRoutingModule { }
